import classNames from 'classnames';

import styles from '../TournamentWidget.module.scss';

type ChampionsActiveRoundWidgetTrophyProps = {
  src: string;
  variant: number | null;
  isOnFinalRound: boolean;
  className?: string;
  onImageError: (e: React.SyntheticEvent<HTMLImageElement>) => void;
};

export function ChampionsActiveRoundWidgetTrophy({
  src,
  variant,
  isOnFinalRound,
  className,
  onImageError,
}: ChampionsActiveRoundWidgetTrophyProps) {
  return (
    <img
      alt="round-trophy"
      className={classNames(
        styles.trophyIconLayer,
        isOnFinalRound && styles.trophyIconLayerFinalRound,
        variant != null && styles[`trophyIconLayerVariant${variant}`],
        className,
      )}
      loading="lazy"
      src={src}
      onError={onImageError}
    />
  );
}
